import type { RouteRecordRaw } from "vue-router";

export const routes = [
  {
    path: "/bol-invoice",
    name: "BOL Invoice",
    component: () => import("./bolInvoice.vue"),
  },
  {
    path: "/choice-payment-posting",
    name: "Choice Payment Posting",
    component: () => import("./choicePaymentPosting.vue"),
  },
] satisfies RouteRecordRaw[];
